// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17M23","left":"styles_left__2gK2Y","desktopActions":"styles_desktopActions__23rMs","title":"styles_title__8Aelb"};